import { default as ErrorsTypes } from '../errors/errors.Types.js';
import { default as ErrorsCustom } from '../errors/errors.Custom.js';

export default class Errors {

  static get Types() { return ErrorsTypes; }
  static get Custom() { return ErrorsCustom; }

}
